<template>
  <div class="setup-eula">
    <div class="update-notification" v-if="contentOwnership.status === 'active'">
      <h1 class="f9">{{ $t('EULA Update') }}</h1>
      <p
        class="f5"
      >{{ $t('When you upload a new EULA, locations get notified and have 7 days to accept it in order to continue using your content, or decline it and have your title automatically removed from their library. We are required to give locations a fair amount of time to review EULA changes, so your old EULA will be in effect during these 7 days.') }}</p>
    </div>
    <EULA :contentOwnership="contentOwnership" v-on="$listeners"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import EULA from '../content-fields/EULA';

@Component({
  components: {
    EULA,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
})
export default class TabEULARoute extends Vue {}
</script>
